// src/components/Common/ProfileMenu.jsx
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { fetchAuthMe, logout } from "../../../api/requests/auth-requests";

const ProfileMenu = (props) => {
  const [menu, setMenu] = useState(false);
  const [username, setUsername] = useState("Admin");
  const [me, setMe] = useState(null);
  const navigate = useNavigate();
  const defaultAvatarSVG =
      "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='64' height='64' fill='%23ccc' viewBox='0 0 24 24'><circle cx='12' cy='8' r='4'/><path d='M4 20c0-4 4-6 8-6s8 2 8 6'/></svg>";

  useEffect(() => {
    const authUser = localStorage.getItem("authUser");
    if (authUser) {
      const obj = JSON.parse(authUser);
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        setUsername(obj.displayName);
      } else {
        setUsername(obj.username);
      }
    }
  }, [props.success]);

  useEffect(() => {
    fetchAuthMe()
        .then((res) => (res.ok ? res.json() : null))
        .then((json) => setMe(json?.data ?? null))
        .catch(() => setMe(null));
  }, [props.success]);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      localStorage.removeItem("authUser");
      localStorage.removeItem("tokenExp");
      navigate("/login");
    }
  };

  return (
      <Dropdown
          isOpen={menu}
          toggle={() => setMenu(!menu)}
          className="d-inline-block"
      >
        <DropdownToggle
            className="btn header-item bg-soft-light border-start border-end"
            id="page-header-user-dropdown"
            tag="button"
        >
          <img
              className="rounded-circle header-profile-user"
              src={defaultAvatarSVG}
              alt="Varsayılan avatar"
          />
          <span className="d-none d-xl-inline-block ms-1 fw-medium">
          {username}
        </span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end py-0 overflow-hidden" style={{ minWidth: 240, maxWidth: 260 }}>
          <div className="px-3 py-2 bg-light border-bottom">
            {[
              { label: "Firma Kodu", value: me?.companyCode },
              { label: "Ad Soyad", value: me?.username || username },
              { label: "Firma Adı", value: me?.companyName },
            ]
                .filter((row) => row.value)
                .map((row) => (
                    <div key={row.label} className="d-flex align-items-baseline gap-1" style={{ fontSize: 14, padding: "3px 0" }}>
                      <span className="text-muted flex-shrink-0" style={{ width: 84 }}>{row.label}:</span>
                      <span className="fw-semibold text-dark text-break">{row.value}</span>
                    </div>
                ))}
          </div>
          <div className="py-1">
            <button
                className="dropdown-item btn"
                onClick={() => navigate("/settings?tab=password")}
                style={{ textAlign: "left", width: "100%" }}
            >
              <i className="mdi mdi-cog font-size-16 align-middle me-1"></i>
              Kullanıcı Ayarları
            </button>
            <button
                className="dropdown-item btn"
                onClick={handleLogout}
                style={{ textAlign: "left", width: "100%" }}
            >
              <i className="mdi mdi-logout font-size-16 align-middle me-1"></i>
              Çıkış yap
            </button>
          </div>
        </DropdownMenu>
      </Dropdown>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.func,
};

const mapStateToProps = (state) => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default connect(
    mapStateToProps,
    {}
)(withTranslation()(ProfileMenu));
